<template>
    <Layout>
        <b-card>
            <b-card-header>
                <b-card-title class="h2">
                    Agenda
                </b-card-title>
            </b-card-header>
            <div class="card-header p-0 nav">
                <div class="row no-gutters" role="tablist">
                    <div class="col-auto">
                        <div
                            @click="view = 'availability'"
                            class="dashboard-area-tabs__tab card-body d-flex flex-row align-items-center justify-content-start pointer"
                            :class="view === 'availability' ? 'active' : ''"
                            data-testid="agenda-tab-availability"
                        >
                                    <span class="flex d-flex flex-column">
                                        <strong>Disponibilidades</strong>
                                    </span>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div
                            @click="view = 'calendar'"
                            class="dashboard-area-tabs__tab card-body d-flex flex-row align-items-center justify-content-start pointer"
                            :class="view === 'calendar' ? 'active' : ''"
                            data-testid="agenda-tab-calendar"
                        >
                                    <span class="flex d-flex flex-column">
                                        <strong>Calendário</strong>
                                    </span>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div
                            @click="view = 'group-sessions'"
                            class="dashboard-area-tabs__tab card-body d-flex flex-row align-items-center justify-content-start pointer"
                            :class="view === 'group-sessions' ? 'active' : ''"
                            data-testid="agenda-tab-group-sessions"
                        >
                                    <span class="flex d-flex flex-column">
                                        <strong>Sessões em grupo</strong>
                                    </span>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div
                            @click="view = 'pendencies'"
                            class="dashboard-area-tabs__tab card-body d-flex flex-row align-items-center justify-content-start pointer"
                            :class="view === 'pendencies' ? 'active' : ''"
                            data-testid="agenda-tab-pendencies"
                        >
                                    <span class="flex d-flex flex-column">
                                        <strong>Pendências</strong>
                                    </span>
                        </div>
                    </div>
                </div>
            </div>
            <b-card-body v-show="view === 'availability'">

                <Schedule/>

            </b-card-body>

            <b-card-body v-if="view === 'calendar'">

                <FullCalendar/>

            </b-card-body>

            <b-card-body v-if="view === 'group-sessions'">

                <GroupSessions/>

            </b-card-body>

            <b-card-body v-if="view === 'pendencies'">

                <SchedulingPendencies/>

            </b-card-body>
        </b-card>
    </Layout>
</template>

<script>
import Layout from '@/components/layout/main.vue';
import Schedule from "./schedule.vue";
import FullCalendar from "./full-calendar-component.vue";
import GroupSessions from "./group-sessions.vue";
import SchedulingPendencies from "./scheduling-pendencies.vue";

export default {
    components: {
        Layout,
        Schedule,
        FullCalendar,
        GroupSessions,
        SchedulingPendencies,
    },

    data() {
        return {
            view: 'availability',
        }
    },
}
</script>
